export default class DynamicDesktopToOverlaySwitcher {
  constructor(navbar) {
    this.navbar = navbar;
    this.ul = $(this.navbar).find(".page-navbar__menu > ul")[0];
    this.$headerButton = $("#header-button");
    this.$headerButtonShort = $("#header-button-short");

    if (this.ul) {
      this._init();
    }
  }

  _init() {
    this.brand = $(this.navbar).find(".page-navbar__brand")[0];
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      this._handelWindowLoad();
    } else {
      window.addEventListener("load", this._handelWindowLoad.bind(this));
    }
  }

  _handelWindowLoad(evt) {
    // If the user can't hover always show the mobil-menu
    if (!window.matchMedia("(hover: hover)").matches) {
      document.body.classList.add("navbar--uses-overlay");
      this.useOverlayToggle = true;
      $(window).trigger("luther:navbar--uses-overlay", [true]);
      // if the user can hover calculate the mobile breakpoint
      this.navbar.classList.add("page-navbar--loaded");
    } else {
      this._getMenuBreakpoint().then((resp) => {
        this.breakpoint = resp.breakpoint;
        this.shortButtonBreakpoint = resp.shortButtonBreakpoint;
        window.addEventListener("resize", this._doSwitchIfNessesary.bind(this));
        this._doSwitchIfNessesary();
        this.navbar.classList.add("page-navbar--loaded");
      });
    }
  }

  _getMenuBreakpoint() {
    return new Promise((resolve) => {
      const extraPadding = 350;

      let menuItems = 0;
      for (let menuItem of this.ul.children) {
        menuItems += menuItem.clientWidth;
      }

      const LogoWidth = document.querySelector(
        ".page-navbar__brand"
      )?.clientWidth;

      const headerButton =
        document.querySelector("#header-button")?.clientWidth;

      const headerButtonShort = document.querySelector(
        "#header-button-short"
      )?.clientWidth;

      const breakpoint =
        menuItems + LogoWidth + extraPadding + headerButtonShort;

      const shortButtonBreakpoint =
        breakpoint - (headerButton - headerButtonShort);

      resolve({ breakpoint, shortButtonBreakpoint });
    });
  }

  _handelWindowResize(evt) {
    this._doSwitchIfNessesary();
  }

  _doSwitchIfNessesary() {
    // Overlay or not
    const useOverlayToggle = this.useOverlayToggle || false;
    if (window.innerWidth < this.shortButtonBreakpoint) {
      if (!useOverlayToggle) {
        document.body.classList.add("navbar--uses-overlay");
        this.useOverlayToggle = true;
        $(window).trigger("luther:navbar--uses-overlay", [true]);
      }
    } else {
      if (useOverlayToggle) {
        document.body.classList.remove("navbar--uses-overlay");
        this.useOverlayToggle = false;
        $(window).trigger("luther:navbar--uses-overlay", [false]);
      }
    }

    // short Formate Button or not
    if (
      window.innerWidth < this.breakpoint &&
      window.innerWidth >= this.shortButtonBreakpoint
    ) {
      this.navbar.classList.add("short-header-button");
    } else {
      this.navbar.classList.remove("short-header-button");
    }
  }
}
